import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Styles from '../GeneralUI/Styles';
import { Paper, InputLabel, Grid, TextField } from '@material-ui/core';
import Textfieldlabel from "../GeneralUI/Textfieldlabel";
import { getDocument } from '../../Actions/General';
import Buttoncontrol from "../GeneralUI/Buttoncontrol";
import Tooltip from '@material-ui/core/Tooltip';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { SnackbarProvider, withSnackbar } from 'notistack';
import Chip from '@material-ui/core/Chip';
import Visibility from '@material-ui/icons/Visibility';
import Utils from '../../Libs/utils';

class Color extends Component {
  state = {
    fields: {
      colorCodigo: null,
      colorNombre: null,
      colorCodigoMinisterio: null,
      createdAt: Utils.fullDateTime(),
      updatedAt: Utils.fullDateTime()
    },
    responseForm: { Message: '', typeMessage: '' }
  };


  componentDidMount() {

    const params = this.props.match.params;

    if (!params.id) {
      return;
    }
           
    getDocument({
      documentId: params.id,
      fieldName: 'colorCodigo',
      moduleName: params.module
    }).then(document => {
      if (!document) {
        return;
      }
      this.setState({ fields: document });
    });

  }

  handleSeguir = () => {
    alert('Seguimiento registrado.');
  }

  handleChange = (event) => {
    let { fields } = this.state;
    if (event.target.type === 'time') {
      fields[event.target.id] = event.target.value;
    } else if (event.target.type === 'number') {
      fields[event.target.id] = event.target.value;
    } else {
      fields[event.target.id] = event.target.value.toUpperCase();
    }
    this.setState({ fields });
  }

  save = (response) => {

    if (response.responseForm && response.responseForm.typeMessage === 'error') {
      this.setState({
        responseForm: response.responseForm
      });
    } else {
      this.setState({
        fields: response.data || this.state.fields, 
        responseForm: response.responseForm
      });      
    }
    if (response.responseForm && response.responseForm.Message) {
        this.props.enqueueSnackbar(
          response.responseForm.Message,
          { variant: response.responseForm.typeMessage || 'info' }
        );
    }
  }


  render() {
    const { classes } = this.props;

    return (

      <Paper elevation={5} className={classes.mainPaper}>
        <form className={this.props.form} onSubmit={e => e.preventDefault()}>

          <Grid container spacing={32} className={classes.gridForm}>

            <InputLabel id="colorCodigo" className={classes.tittleLabelForm}>
              Color
            </InputLabel>

            <Grid item xs={6} className={classes.chipTitle}>
              {this.state.fields["colorCodigo"] !== null ?
                (<Chip
                  label={this.state.fields["colorCodigo"]}
                  clickable
                  color="primary"
                  onDelete={this.handleSeguir}
                  deleteIcon={<Tooltip title="Seguir" placement="right-start"><Visibility /></Tooltip>}
                />) : ''
              }
            </Grid>
          </Grid>

          <Grid container spacing={32}>
            <Grid item xs={3} className={classes.gridForm}>
              <TextField
                id='colorNombre'
                type='text'
                label='Color Nombre (*)'
                margin="normal"
                variant="outlined"
                value={this.state.fields.colorNombre}
                onChange={this.handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={3} className={classes.gridForm}>
              <TextField
                id='colorCodigoMinisterio'
                type='text'
                label='Color Codigo Ministerio (*)'
                margin="normal"
                variant="outlined"
                value={this.state.fields.colorCodigoMinisterio}
                onChange={this.handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={32} >
            <Grid item xs={3} className={classes.gridForm}>
              <Textfieldlabel label="Usuario" value={Utils.getFromLocalStorage('userInfo').usuarioNombreCompleto} />
            </Grid>
            <Grid item xs={3} className={classes.gridForm}>
              <Textfieldlabel label="Fecha Creacion" value={this.state.fields.createdAt} />
            </Grid>
            <Grid item xs={3} className={classes.gridForm}>
              <Textfieldlabel label="Fecha Modificacion" value={this.state.fields.updatedAt} />
            </Grid>
          </Grid>
        </form>

        <div id='buttonContainer'>
          <Buttoncontrol
            saveData={this.state.fields}
            moduleName={this.props.match.params.module}
            save={this.save}
            primaryFields={['colorCodigo']} />
        </div>

      </Paper>
    );
  }
}

Color.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
};

const MyApp = withRouter(withSnackbar(withStyles(Styles, { withTheme: true })(Color)));

function IntegrationNotistack() {
  return (
    <SnackbarProvider maxSnack={1}
      action={[
        <Button variant="text" color="primary" size="small">
          {'X'}
        </Button>
      ]}

    >
      <MyApp />
    </SnackbarProvider>
  );
}


export default IntegrationNotistack;